export const CREATE_CLINIC = "CREATE_CLINIC"
export const GET_CLINICS = "GET_CLINICS"
export const SET_CLINICS = "SET_CLINICS"
